<template>
  <v-app>
    <v-app-bar app dense>
      <v-app-bar-nav-icon
        v-if="isMobile"
        aria-label="Меню"
        @click="showDrawer = !showDrawer"
      />
      <v-toolbar-title>
        <app-breadcrumbs />
      </v-toolbar-title>

      <v-spacer v-if="!isMobile" />

      <help-dialog v-if="!isMobile" />

      <logout-dialog v-if="!isMobile" />
    </v-app-bar>

    <app-sidebar v-model="showDrawer" />

    <v-main>
      <router-view />
    </v-main>

    <notification-center />
  </v-app>
</template>

<script>
import AppSidebar from "./components/AppSidebar";
import LogoutDialog from "@/components/auth/LogoutDialog";
import HelpDialog from "./components/HelpDialog.vue";
import AppBreadcrumbs from "./components/AppBreadcrumbs";

import * as jwtService from "@/services/jwt.service";
import * as sessionService from "@/services/session.service";
import { LOGIN_ROUTE } from "@/router/names";
import NotificationCenter from "./components/NotificationCenter";

export default {
  name: "App",
  components: {
    NotificationCenter,
    LogoutDialog,
    AppSidebar,
    HelpDialog,
    AppBreadcrumbs
  },

  data: () => ({
    showDrawer: null
  }),

  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  },

  watch: {
    isMobile: {
      immediate: true,
      handler(val) {
        this.showDrawer = !val;
      }
    }
  },

  async created() {
    jwtService.jwtEnabled() && jwtService.checkEach(50 * 1000);
    if (sessionService.initSession()) return;
    return await this.$router.replace({ name: LOGIN_ROUTE });
  }
};
</script>

<style>
@media (max-width: 600px) {
  .v-dialog {
    max-width: 95vw !important;
    margin: 16px;
  }

  .container,
  .container--fluid {
    padding: 8px;
  }

  .v-card__text,
  .v-card__title {
    padding: 8px !important;
  }

  .v-tab {
    min-width: auto !important;
    padding: 0 12px !important;
  }
}

.v-btn--icon,
.v-btn--icon.v-size--default {
  min-width: 44px;
  min-height: 44px;
}

.v-icon--link {
  min-width: 44px;
  min-height: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.filter-toolbar .v-toolbar__content {
  flex-direction: column;
  align-items: stretch;
  padding: 8px;
}
</style>
